export default __webpack_public_path__ + "static/media/grocery.076a5c1d.svg";